module.exports = __webpack_public_path__ + "img/un-verre.827bfc30.webp";